<template>
    <v-form v-model="valid" ref="form">
    <v-container fluid class="mt-4">
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-text-field label="Description on sales forms" v-model="nonExcise.sellingDescription" :rules="[fieldRules.maxLength(50)]" :counter="50" outlined dense/>
        </v-col>
      </v-row>

      <v-row dense v-if="values && connectedToAccounting">
        <v-col cols="12" sm="6" md="4">
          <account-picker v-model="nonExcise.incomeAccountRef" label="Income account"
                          :accounts="incomeAccounts" :addTypes="['Income']"
                          hint="The income account is used to track sales of this nonExcise."/>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <account-picker v-model="nonExcise.cogAccountRef" label="Expense account"
                          :accounts="cogAccounts" :addTypes="['CostOfGoodsSold']"
                          hint="The cost of goods account is used to track sales of this non-excise"/>
        </v-col>
      </v-row>

      <v-row >
        <v-col cols="6" sm="3" md="2">
          <decimal-number-input dense label="Default price" v-model="nonExcise.defaultPrice" :precision="4" suffix="/litre"/>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <v-autocomplete  outlined dense label="Default tax" v-model="nonExcise.defaultTaxId" :items="taxes" item-value="id" item-text="name"/>
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <v-checkbox dense label="Commission exempt" v-model="nonExcise.commissionExempt"/>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" md="10" lg="8">
          <customer-pricing :customers="nonExcise.customers" :taxes="taxes" units="litre"
                            :default-sku="nonExcise.sku" :defaultPrice="nonExcise.defaultPrice" :defaultTaxId="nonExcise.defaultTaxId"/>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import CustomerPricing from '@/components/CustomerPricing'
import barcode from '@/mixins/barcode'

export default {
  name: 'AlcoholNonPortablesEditSelling',
  components: {CustomerPricing},
  mixins: [barcode],
  props: {
    nonExcise: {type:Object, required:true},
    taxes: {type:Array, required:true},
    incomeAccounts: {type:Array, required:true},
    cogAccounts: {type:Array, required:true},
    values: {type:Boolean, required:true}
  },
  data() {
    return {
      valid: true
    }
  },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    }
  }
}
</script>